// extracted by mini-css-extract-plugin
module.exports = {"floating-icon":"Home_floating-icon__2srTK","whatsapp-icon":"Home_whatsapp-icon__TYK_h","phone-icon":"Home_phone-icon__3ezem"};